import React from "react";
import styled from "styled-components";
import { string, func, bool } from "prop-types";

import Typography from "../shared/Typography";
import CitroenIcon from "../shared/Icons/Citroen";
import FnacDartyIconContainer from "../shared/FnacDartyIconContainer";

import { prop } from "../shared/utils";
import { TEST_DRIVE_TYPE_ID } from "@shared/constants";

const StyledListItem = styled.li`
  border-bottom: solid 4px ${prop("color")};
  cursor: pointer;
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  list-style: none;
  margin-top: 1rem;
  max-width: 5rem;
  padding-bottom: 0.3rem;
`;

const IconContainer = styled.div`
  align-self: center;
  background: #${prop("backgroundColor")};
  border-radius: 50%;
  padding: 0.5rem;
  min-width: 35.5px;
  display: flex;
  justify-content: center;
  min-height: 35.5px;
  ${({ isSelected }) => !isSelected && "filter: grayscale(1)"};
  ${({ isSelected }) => !isSelected && "opacity: 0.5"};
`;

const Title = styled(Typography)`
  color: ${prop("color")};
  font-size: 0.8rem;
  font-weight: 700;
  margin-top: 1rem;
  text-align: center;
  text-transform: uppercase;
`;

const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${({ isSelected }) => !isSelected && "filter: grayscale(1)"};
`;

const MapFilterItem = ({
  color,
  title,
  type,
  filterEvent,
  isSelected,
  ...props
}) => (
  <StyledListItem color={color} onClick={filterEvent} {...props}>
    {type === TEST_DRIVE_TYPE_ID.FNAC_DARTY ? (
      <LogosContainer isSelected={isSelected}>
        <FnacDartyIconContainer
          dataId={`point-logo-${type}`}
          isOrientationHorizontal={false}
        />
      </LogosContainer>
    ) : (
      <IconContainer backgroundColor={color} isSelected={isSelected}>
        <CitroenIcon />
      </IconContainer>
    )}
    <Title color={color}>{title}</Title>
  </StyledListItem>
);

MapFilterItem.propTypes = {
  color: string.isRequired,
  isSelected: bool.isRequired,
  title: string.isRequired,
  type: string.isRequired,
  filterEvent: func.isRequired,
};

export default MapFilterItem;
